import SectionMessage, { Appearance } from '@atlaskit/section-message';
import React from 'react';

export interface InfoPanelProps {
  type: Appearance;
  title?: string;
  message: React.ReactNode;
  detailList?: (() => JSX.Element)[];
}

export default function InfoPanel({ type, title, message, detailList }: React.PropsWithChildren<InfoPanelProps>) {
  return (
    <SectionMessage title={title} appearance={type}>
      <div>{message}</div>
      {detailList && (
        <>
          {detailList.map((DetailItem, index) => (
            <>
              <DetailItem key={index} />
              {index !== detailList.length - 1 && <hr />}
            </>
          ))}
        </>
      )}
    </SectionMessage>
  );
}
